import Etablissements from "../app/modules/Recrutement/Parametrage/Etablissements";
import Paramrecrut from "../app/modules/Recrutement/Parametrage/Paramrecrut";
import DashboardRecrutementRH from "../app/modules/Recrutement/Dashboards/DashboardForecast";
import ChasseurDeTete from "../app/modules/Recrutement/ResponsableRH/RessourcesJS/ChasseureDeTete/ChasseursDeTete";
import AjouterChasseurDeTete
    from "../app/modules/Recrutement/ResponsableRH/RessourcesJS/ChasseureDeTete/AjouterChasseurDeTete";
import PartenaireAcademique
    from "../app/modules/Recrutement/ResponsableRH/RessourcesJS/PartenairesAcadémiques/Partenaireacademique";
import ActionsPreEmbauche from "../app/modules/Recrutement/ResponsableRH/ActionsPréembauche/Actionspreembauche";
import CVTheque from "../app/modules/Recrutement/ResponsableRH/RessourcesJS/CvThèque/Cvtheque";
import TraitementDemandes from "../app/modules/Recrutement/ResponsableRH/TraitementDesDemandes/Traitementdemandes";
import TraitementCandidature from "../app/modules/Recrutement/Manger/TraitementDesCandidats/Traitementcandidature";
import DemandeRecrutement from "../app/modules/Recrutement/Manger/DemandeDeRecrutement/Demandesrecrutement";
import CampagneManagement
    from "../app/modules/Formation/ResponsableFormation/RessourcesJs/campagnes/CampagneManagement";
import CampagneFormModal from "../app/modules/Formation/ResponsableFormation/RessourcesJs/campagnes/CampagneFormModal";
import CampagneRecrutement from "../app/modules/Recrutement/ResponsableRH/Campagne/CampagneRecrutement";
import EvaluationRecrutementManagement
    from "../app/modules/Recrutement/ResponsableRH/Evaluations/EvaluationRecrutementManagement";
import CareersPage from "../app/modules/Recrutement/Cicada-carrerrs/CareersPage";
import RecruitmentCandidateEvaluationPage from "../app/modules/Recrutement/pages/RecruitmentCandidateEvaluationPage";

export const RecrutementRoutes = [

    // ===== PARAMETRAGE =====
    { path: "/etablissements", element: <Etablissements /> },
    { path: "/recrutement/parametrage", element: <Paramrecrut /> },
    { path: "/recrutement/responsable/evaluations", element: <EvaluationRecrutementManagement /> },

    // ===== DASHBOARD =====
    { path: "/recrutement/responsable/dashboard", element: <DashboardRecrutementRH /> },

    // Ancienne route dashboard (si vous la gardez)
    { path: "/recrutement/Dashboards/Dashboard-cards-etats", element: <DashboardRecrutementRH /> },

    // ===== CHASSEURS DE TETE =====
    { path: "/recrutement/responsable/chasseurs-de-tete", element: <ChasseurDeTete /> },
    { path: "/recrutement/responsable/chasseurs-de-tete/add", element: <AjouterChasseurDeTete /> },
    { path: "/recrutement/responsable/chasseurs-de-tete/edit/:cid", element: <AjouterChasseurDeTete /> },

    // ===== RESSOURCES =====
    { path: "/recrutement/responsable/partenaires-academiques", element: <PartenaireAcademique /> },
    { path: "/recrutement/responsable/candidats", element: <ActionsPreEmbauche /> },
    { path: "/recrutement/responsable/cvTheque/liste", element: <CVTheque /> },

    { path: "/recrutement/responsable/campagnes/liste", element: <CampagneRecrutement/> },
    { path: "/recrutement/responsable/campagnes/add", element: <CampagneFormModal /> },
    { path: "/recrutement/responsable/campagnes/:id/edit", element: <CampagneFormModal /> },

    // ===== TRAITEMENT DEMANDES =====
    { path: "/recrutement/responsable/traitement-demandes", element: <TraitementDemandes /> },

    // ===== MANAGER =====
    { path: "/recrutement/manager/traitement-candidats", element: <TraitementCandidature /> },
    { path: "/recrutement/manager/demandes", element: <DemandeRecrutement /> },
    { path: "/recrutement/responsable/careers-page", element: <CareersPage /> },

    { path: "/recrutement/evaluations/:evaluationId/candidatures/:candidatureId/fiche", element: <RecruitmentCandidateEvaluationPage /> },
    { path: "/recrutement/evaluations/candidatures/:candidatureId/fiche", element: <RecruitmentCandidateEvaluationPage /> },

];






